<script>
  import {PlusIcon, XIcon, Edit3Icon} from 'vue-feather-icons'
  import {addressTypesComputed, addressTypesMethods, countriesComputed, countriesMethods} from '@state/helpers'

  export default {
    components: {
      PlusIcon,
      XIcon,
      Edit3Icon
    },
    props: {
      addresses: {
        type: Array,
        required: true
      },
      validation: {
        type: [Array, Object],
        required: true
      }
    },
    computed: {
      ...countriesComputed,
      ...addressTypesComputed,
    },
    mounted() {
      this.getCountries()
      this.getAddressTypes({limit: 500, type: ['staff','default']})
    },
    methods: {
      ...addressTypesMethods,
      ...countriesMethods,
      addAddress() {
        this.addresses.push(
          {
            types: [],
            line_1: '',
            state: '',
            city: '',
            postcode: '',
            is_primary: false,
            country: {},
            is_edit: true
          }
        );
      },

      removeAddress(index) {
        this.addresses.splice(index, 1)
      },

      toggleEdit(index) {
        const address = this.addresses[index]
        address.is_edit = address.is_edit ? !address.is_edit : true
        this.addresses.splice(index, 1)
        this.addresses.splice(index, 0, address)
      },

      disableEdit(index) {
        const address = this.addresses[index]
        address.is_edit = false
        this.addresses.splice(index, 1)
        this.addresses.splice(index, 0, address)
      },

      parseAddressValidation(validation, index) {
        return {
          line_1: validation['addresses.' + index + '.line_1'] || null,
          suburb: validation['addresses.' + index + '.suburb'] || null,
          state: validation['addresses.' + index + '.state'] || null,
          city: validation['addresses.' + index + '.city'] || null,
          postcode: validation['addresses.' + index + '.postcode'] || null,
          country_id: validation['addresses.' + index + '.country_id'] || null,
        }
      },
      resetValidation(addressData, placeResultData, id) {
        this.$emit('changed', addressData, placeResultData, id)
      }
    }
  }
</script>

<template>
  <div class="form-content pt-3">
    <div v-for="(address, index) in addresses" :key="index">
      <div v-if="address.id" class="edit-form-item my-2">
        <div class="item-info">
          <div class="col-md-6 left-ct">
            <p class="tx-value mg-b-0 text-bold">{{ address | getStringFromObjectAddress }}</p>
          </div>
          <div class="col-md-6 right-ct">
            <span class="block-status border rounded-pill pl-1 pr-3">
              <span
                :class="['status-icon', { 'status-completed': address.is_primary }, { 'status-request': !address.is_primary }]"></span>
              <span class="status-text">
                <span v-if="address.types[0]">{{address.types[0]}}</span> <span
                  v-if="address.is_primary">(Primary)</span>
              </span>
            </span>
          </div>
        </div>
        <div class="action-group mg-l-auto tw-flex-shrink-1">
          <button type="button" class="btn btn-icon button-action button-action-edit" @click="toggleEdit(index)">
            <Edit3Icon size="1x" class="custom-class"></Edit3Icon>
          </button>
          <button type="button" class="btn btn-icon button-action button-action-negative" @click="removeAddress(index)">
            <XIcon size="1x" class="custom-class"></XIcon>
          </button>
        </div>
      </div>
      <div v-show="!address.id || address.is_edit" class="border border-radius-20 mt-3 pd-20 bg-gray">
        <BaseAddressLookup
          :id="`addresses-lookup-${index}`"
          :address="address"
          :validation="parseAddressValidation(validation, index)"
          self-handle-address
          show-address-type
          @changed="resetValidation"
        >
          <div class="action-group mg-l-auto tw-flex-shrink-1 float-right">
            <button
              type="button"
              class="btn btn-icon button-action button-action-negative"
              @click="address.id ? toggleEdit(index) : removeAddress(index)">
              <XIcon size="1x" class="custom-class"></XIcon>
            </button>
          </div>
        </BaseAddressLookup>
      </div>
    </div>

    <div class="group-button">
      <button type="button" class="btn button-bd-dashed" @click="addAddress">
        <PlusIcon size="1.5x" class="custom-class float-left mr-2"></PlusIcon>
        <span class="item-text">Add address</span>
      </button>
    </div>
  </div>
</template>
